import { readRuntimeConfig } from './runtime-config';

const runtimeConfig = readRuntimeConfig();

export const environment = {
  version: '0.01',
  production: false,
  BACKEND: runtimeConfig.BACKEND || 'http://localhost:3000',
  STATIC: runtimeConfig.STATIC || 'https://static.autof.com.ua'
};
